import { BOUNDS_OFFSET } from 'shared/constants/map';

const computeBoundsFromCoordinates = (
  coordinates,
  lngFilter = lng => lng /* no filter */
) =>
  coordinates.reduce(
    ({ west, north, east, south }, { latitude: lat, longitude: lng }) => ({
      west: lngFilter(west) >= lngFilter(lng) ? lng - BOUNDS_OFFSET : west,
      north: north <= lat ? lat + BOUNDS_OFFSET : north,
      east: lngFilter(east) <= lngFilter(lng) ? lng + BOUNDS_OFFSET : east,
      south: south >= lat ? lat - BOUNDS_OFFSET : south
    }),
    {
      west: coordinates[0].longitude,
      north: coordinates[0].latitude,
      east: coordinates[0].longitude,
      south: coordinates[0].latitude
    }
  );

export default coordinates => {
  if (coordinates[0]) {
    const bounds = computeBoundsFromCoordinates(coordinates);
    if (bounds.east - bounds.west > 180) {
      return computeBoundsFromCoordinates(
        coordinates,
        lng => (lng <= 0 ? lng + 360 : lng) /* reverse negative coordinates */
      );
    }
    return bounds;
  }
  return undefined;
};
